document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.before-after-container');
    const imageWrapper = document.querySelector('.image-wrapper');
    const afterImage = document.querySelector('.after');
    const handle = document.querySelector('.slider-handle');
    let isDragging = false;

    function updateImages(x) {
      const rect = container.getBoundingClientRect();
      let percentage = ((x - rect.left) / rect.width) * 100;
      percentage = Math.min(100, Math.max(0, percentage));

      requestAnimationFrame(() => {
        afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
        handle.style.left = `${percentage}%`;
      });
    }

    function startDragging(e) {
      isDragging = true;
      const x = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      updateImages(x);
      handle.style.background = '#f0f0f0';
      e.preventDefault();
    }

    function stopDragging() {
      isDragging = false;
      handle.style.background = '#fff';
    }

    function onMove(x) {
      if (!isDragging) return;
      updateImages(x);
    }

    imageWrapper.addEventListener('mousedown', startDragging);
    document.addEventListener('mousemove', (e) => onMove(e.clientX));
    document.addEventListener('mouseup', stopDragging);

    imageWrapper.addEventListener('touchstart', startDragging);
    document.addEventListener(
      'touchmove',
      (e) => {
        if (isDragging) {
          e.preventDefault();
          onMove(e.touches[0].clientX);
        }
      },
      { passive: false }
    );
    document.addEventListener('touchend', stopDragging);

    updateImages(container.getBoundingClientRect().left + (container.getBoundingClientRect().width * 0.5));
  });